import { Icon, IconName } from '@zapier/design-system';

// TODO: Add toggle button later. See ActionChip.tsx for more details.

// export type ActionChipToggleGroupProps = ToggleButtonGroupProps;
// export const ActionChipToggleGroup = (props: ActionChipToggleGroupProps) => {
//   return <ToggleButtonGroup {...props} />;
// };

export type ActionChipIconProps = {
  /** The name of icon to display. If the name is invalid, a square will be rendered instead. */
  name: IconName;
};
/** An icon whose styles will dynamically adjust when passed as a child to `ActionChip`. */

export const ActionChipIcon = ({ name }: ActionChipIconProps) => (
  <Icon name={name} />
);
